import React from "react";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import TagFilter from "../../../common/components/molecule/TagFilter/TagFilter";
import { MeterV2List } from "../../../features/meter";
import {
  SearchContextProvider,
  useSearchContext,
} from "../../../features/meter/components/MeterV2List/SearchContext";
import { useKnownMeterTags } from "../../../features/meterTags/hooks/useMeterTags";

import styles from "./ClientListPage.module.scss";

function MeterTagFilter() {
  const { selectedTags, setSelectedTags } = useSearchContext();
  const knownTags = useKnownMeterTags();
  return <TagFilter value={selectedTags} onChange={setSelectedTags} suggestions={knownTags} />;
}

export default function ClientListPage() {
  return (
    <SearchContextProvider>
      <div className={styles["page-container"]}>
        <HeaderTitleContent>Compteurs</HeaderTitleContent>
        <div className={styles["header-page"]}>
          <div className={styles["header-page__search"]}>
            <MeterV2List.InputSearch />
          </div>
        </div>
        <MeterTagFilter />
        <MeterV2List.List />
      </div>
    </SearchContextProvider>
  );
}
